import { useRootStore } from "app/useRootStore";
import axios from "axios";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { handleErrorApiResponse } from "shared/api/interceptors/globalApiErrorHandler";
import apiConstants from "shared/constants/apiConstants";
import { useLocalize } from "shared/hooks/useLocalize";

let globalRequestInterceptor: number | null = null;
let globalResponseInterceptor: number | null = null;

export function withGlobalApiInterceptors<Props>(WrappedComponent: React.ComponentType<Props>): React.FC<Props> {
    return (props: Props) => {
        const history = useHistory();
        const localize = useLocalize();
        const { rootStore } = useRootStore();

        globalRequestInterceptor = useMemo(() => {
            if (globalRequestInterceptor !== null) {
                axios.interceptors.response.eject(globalRequestInterceptor);
            }

            return axios.interceptors.request.use(
                request => {
                    if (request.withMyDepositToken) {
                        request.headers[apiConstants.HEADERS.MY_DEPOSIT_AUTHORIZATION] =
                            rootStore.myDepositStore.accessToken;
                    }

                    return request;
                },
                error => error
            );
        }, [rootStore]);

        globalResponseInterceptor = useMemo(() => {
            if (globalResponseInterceptor !== null) {
                axios.interceptors.response.eject(globalResponseInterceptor);
            }

            return axios.interceptors.response.use(
                response => response,
                error => handleErrorApiResponse(error, history, localize, rootStore)
            );
        }, [rootStore, history, localize]);

        return <WrappedComponent {...props} />;
    };
}
